<template>
  <component class="data-table-icon" :is="icon" />
</template>

<script lang="ts" setup>
import { PropType } from 'vue';
import { DataTableIcons } from '@/shared/components/dataTable/dataTableIcons';

defineProps({
  icon: {
    type: String as PropType<keyof typeof DataTableIcons>,
    required: true,
  },
});
</script>

<style scoped lang="scss">
.data-table-icon {
  margin-bottom: 3px;
}

.person-icon {
  width: 14px;
  height: 14px;
  margin-bottom: 3px;
  padding: 0;
}
</style>
